import * as XLSX from 'xlsx';
import { googleDriveService } from './googleDriveService';
import { productService } from './api';

class ImportService {

  // 🔧 RÉPARATION ENCODAGE 3 NIVEAUX (source unique de vérité)
  //    1. Mojibake : UTF-8 interprété comme Latin-1 (Ã© → é)  → re-décodage
  //    2. Dictionnaire : mots français connus avec U+FFFD     → remplacement exact
  //    3. Fallback contextuel : � isolé                       → heuristique (é/è/à/ç/œ)
  static repairMojibake(raw) {
    if (raw == null) return '';
    const input = String(raw);
    if (input.length === 0) return input;
    if (!input.includes('\uFFFD') && !/[ÃÂÄÆæŒœ€]/.test(input)) return input;

    let s = input;

    // --- Niveau 1 : Mojibake (UTF-8 stocké en Latin-1) ---
    if (/[ÃÂÄÆæŒœ€]/.test(s)) {
      try {
        const bytes = new Uint8Array(s.length);
        let hasHigh = false;
        let anyBad = false;
        for (let i = 0; i < s.length; i++) {
          const c = s.charCodeAt(i);
          if (c < 0 || c > 255) { anyBad = true; break; }
          if (c > 127) hasHigh = true;
          bytes[i] = c;
        }
        if (!anyBad && hasHigh) {
          const decoder = new TextDecoder('utf-8', { fatal: false });
          const decoded = decoder.decode(bytes);
          const nOld = (s.match(/\uFFFD/g) || []).length;
          const nNew = (decoded.match(/\uFFFD/g) || []).length;
          if (!decoded.includes('\uFFFD') || nNew < nOld) s = decoded;
        }
      } catch (_) {}
    }

    if (!s.includes('\uFFFD')) return s;

    // --- Niveau 2 : Dictionnaire de mots français (U+FFFD → accent correct) ---
    const DICT = [
      [/monophas�/gi, 'monophasé'],
      [/triphas�/gi, 'triphasé'],
      [/phas�/gi, 'phasé'],
      [/r�seau/gi, 'réseau'],
      [/r�gl(e|er|es|ement|ages|age|ez|era|erai|erons|erez|aient|ant)/gi, (m, p) => 'régl' + p],
      [/r�sult(at|ats|er|era|erai|erons|erez)/gi, (m, p) => 'résult' + p],
      [/r�serv(e|er|es|ation|ez|era|erai|erons|erez)/gi, (m, p) => 'réserv' + p],
      [/r�union(s)?/gi, (m, p) => 'réunion' + (p || '')],
      [/r�duis(ant|ance|re|ez|era|erai|erons|erez)/gi, (m, p) => 'réduis' + p],
      [/r�cup(e|er|ere|erez|erai|erons|erez|ération|érations)/gi, (m, p) => 'récup' + p],
      [/r�f�renc(e|es|er|ez|era|erai|erons|erez)/gi, (m, p) => 'référenc' + p],
      [/r�ception(s)?/gi, (m, p) => 'réception' + (p || '')],
      [/r�ceptionn(e|er|ez|era|erai|erons|erez)/gi, (m, p) => 'réceptionn' + p],
      [/r�act(e|eur|eurs|er|ez|if|ifs|ive|ives|era|erai|erons|erez)/gi, (m, p) => 'réact' + p],
      [/r�el(le|lles|s)?/gi, (m, p) => 'réel' + (p || '')],
      [/r�gion(s)?/gi, (m, p) => 'région' + (p || '')],
      [/r�gime(s)?/gi, (m, p) => 'régime' + (p || '')],
      [/r�par(e|er|ez|era|erai|erons|erez|ation|ations)/gi, (m, p) => 'répar' + p],
      [/r�p�t(e|er|ez|era|erai|erons|erez|ition|itions)/gi, (m, p) => 'répét' + p],
      [/r�ponse(s)?/gi, (m, p) => 'réponse' + (p || '')],
      [/r�pond(re|ez|era|erai|erons|erez|ant|er)/gi, (m, p) => 'répond' + p],
      [/r�ussi(e|te|tes|r|re|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'réussi' + p],
      [/r�sidu(e|el|els|elle|elles|s)?/gi, (m, p) => 'résidu' + (p || '')],
      [/r�sist(ance|antes?|ant|er|ez|era|erai|erons|erez)/gi, (m, p) => 'résist' + p],
      [/r�solu(e|s|tion|tions)?/gi, (m, p) => 'résolu' + (p || '')],
      [/r�v(e|er|ez|es|ement|era|erai|erons|erez|ision|isions)/gi, (m, p) => 'rêv' + p],
      [/r�veil(s)?/gi, (m, p) => 'réveil' + (p || '')],
      [/r�veill(e|er|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'réveill' + p],
      [/r�vol(t|ter|ez|era|erai|erons|erez|ution|utions)/gi, (m, p) => 'révol' + p],

      [/t�l�(phone|charger|cope|path|com|gramme|marketing|communication|surveillance|vision|scopie|grammes|phones|viseur|viseurs|faisceau|faisceaux|cran|crans)/gi, (m, p) => 'télé' + p],
      [/t�l(é|e)?/gi, (m) => m[0] === m[0].toUpperCase() ? 'Tél' : 'tél'],
      [/t�moin(s)?/gi, (m, p) => 'témoin' + (p || '')],
      [/t�l�commande(s)?/gi, (m, p) => 'télécommande' + (p || '')],
      [/t�l�phoni(e|que|ques|er|ez|era|erai|erons|erez)/gi, (m, p) => 'téléphoni' + p],
      [/t�l�vision(s)?/gi, (m, p) => 'télévision' + (p || '')],
      [/t�l�surveillance/gi, 'télésurveillance'],

      [/�lect(rique|ronique|rification|rificat|eur|eurs|roménager|ro|ive|r|ries|rie|eur|eurs|rodomestique|rodomestiques|risabilit|risables?)/gi, (m, p) => 'élect' + p],
      [/�nerg(ie|étique|étiques|ys|ies|étique|tique|tiques)/gi, (m, p) => 'énerg' + p],
      [/�cran(s)?/gi, (m, p) => 'écran' + (p || '')],
      [/�coute(s|ur|urs|rice|rices|z|aient|ait|ant|er|ez|era|erai|erons|erez)?/gi, (m, p) => 'écoute' + (p || '')],
      [/�cole(s)?/gi, (m, p) => 'école' + (p || '')],
      [/�conom(ie|ique|iques|iquement|istes?|iste)/gi, (m, p) => 'économ' + p],
      [/�gal(iser|ement|ité|e|is|isations|isation|s|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'égal' + p],
      [/�viter/gi, 'éviter'],
      [/�vit(e|ez|era|erai|erons|erez|ant|es)/gi, (m, p) => 'évit' + p],
      [/�v�nement(s)?/gi, (m, p) => 'événement' + (p || '')],
      [/�quip(e|er|ez|era|erai|erons|erez|ant|ement|ements)/gi, (m, p) => 'équip' + p],
      [/�quipement(s)?/gi, (m, p) => 'équipement' + (p || '')],
      [/�tend(ue|ues|u|re|res|ez|era|erai|erons|erez|ant|re)?/gi, (m, p) => 'étend' + (p || '')],
      [/�tage(s)?/gi, (m, p) => 'étage' + (p || '')],
      [/(?<![a-zA-Z])�t(e|es|ait|aient|ant|ez|era|erai|erons|erez|re|r|uve|uves|é|e)/gi, (m, p) => 'ét' + p],
      [/�tabl(e|ir|it|issons|issez|issent|issement|issements|eau|eaux)/gi, (m, p) => 'établ' + p],
      [/�tanch(e|es|éit|éité|ement|ements)/gi, (m, p) => 'étanch' + p],
      [/�tat(s)?/gi, (m, p) => 'état' + (p || '')],
      [/�tudiant(s)?/gi, (m, p) => 'étudiant' + (p || '')],
      [/�tude(s)?/gi, (m, p) => 'étude' + (p || '')],
      [/�vanou(ir|it|issons|issez|issent|issant|ie)/gi, (m, p) => 'évanou' + p],
      [/�veil(l|le|les|ler|lez|lera|lerai|lerons|lerez|lait|laient|lant)/gi, (m, p) => 'éveil' + p],
      [/�vident(e|es)?/gi, (m, p) => 'évident' + (p || '')],
      [/�vou�/gi, 'évoué'],
      [/�paule(s)?/gi, (m, p) => 'épaule' + (p || '')],
      [/�pais(e|ses|sse|sses)/gi, (m, p) => 'épais' + p],
      [/�paisseur(s)?/gi, (m, p) => 'épaisseur' + (p || '')],
      [/�pous(e|er|ez|era|erai|erons|erez|ant|es)/gi, (m, p) => 'épous' + p],
      [/�poxy/gi, 'époxy'],
      [/�preuve(s)?/gi, (m, p) => 'épreuve' + (p || '')],
      [/�purer/gi, 'épurer'],
      [/�pur(e|es|er|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'épur' + p],

      [/acc�s(s|ible|ibilité|oires)?/gi, (m, p) => 'accès' + (p || '')],
      [/acit�/gi, 'acité'],
      [/capacit�(s)?/gi, (m, p) => 'capacité' + (p || '')],
      [/qualit�(s)?/gi, (m, p) => 'qualité' + (p || '')],
      [/num�ro(s)?/gi, (m, p) => 'numéro' + (p || '')],
      [/cat�gorie(s)?/gi, (m, p) => 'catégorie' + (p || '')],
      [/d�fin(ition|itive|ir|iss|ie|is|issent|issons|issez|i)/gi, (m, p) => 'défin' + p],
      [/d�pense(s)?/gi, (m, p) => 'dépense' + (p || '')],
      [/d�tection(s)?/gi, (m, p) => 'détection' + (p || '')],
      [/d�t�ct(e|eur|eurs|er|ez|era|erai|erons|erez|if|ifs|ive|ives)/gi, (m, p) => 'détect' + p],
      [/d�clenche(r|ez|era|erai|erons|erez|ant|ement|ements|eur|eurs)/gi, (m, p) => 'déclenche' + p],
      [/d�claration(s)?/gi, (m, p) => 'déclaration' + (p || '')],
      [/d�faut(s)?/gi, (m, p) => 'défaut' + (p || '')],
      [/d�favoris(e|er|ez|era|erai|erons|erez)/gi, (m, p) => 'défavoris' + p],
      [/d�gr�(e|s|er|ez|era|erai|erons|erez|ant|ation|ations)/gi, (m, p) => 'dégrad' + p],
      [/d�mar(r|ch|age|er|e|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'démar' + p],
      [/d�pann(e|er|ez|era|erai|erons|erez|age|ages)/gi, (m, p) => 'dépann' + p],
      [/d�ploi(e|er|ez|era|erai|erons|erez|ant|ement|ements)/gi, (m, p) => 'déploi' + p],
      [/d�port(e|er|ez|era|erai|erons|erez|ant|s)?/gi, (m, p) => 'déport' + p],
      [/d�r(ive|ives|iver|ez|era|erai|erons|erez|ant|é|e|es|ait|aient)/gi, (m, p) => 'dériv' + p],
      [/d�sir(e|er|ez|era|erai|erons|erez|ant|eux|euses)/gi, (m, p) => 'désir' + p],
      [/d�sserv(ir|it|ice|ices|ez|ira|irai|irons|irez|issant)/gi, (m, p) => 'désserv' + p],
      [/d�tail(s)?/gi, (m, p) => 'détail' + (p || '')],
      [/d�velopp(e|er|ez|era|erai|erons|erez|ant|ement|ements)/gi, (m, p) => 'développ' + p],
      [/d�verrouill(e|er|ez|era|erai|erons|erez|age|ages)/gi, (m, p) => 'déverrouill' + p],
      [/d�viss(e|er|ez|era|erai|erons|erez|age|ages)/gi, (m, p) => 'déviss' + p],

      [/v�rifi(er|ez|era|erai|erons|erez|ant|ation|ations|e|es|ait|aient|if|ifs|ive|ives)/gi, (m, p) => 'vérifi' + p],
      [/v�g�t(ation|al|aux|aux|er|ez|era|erai|erons|erez)/gi, (m, p) => 'végét' + p],
      [/v�hicule(s)?/gi, (m, p) => 'véhicule' + (p || '')],
      [/v�lo(s)?/gi, (m, p) => 'vélo' + (p || '')],
      [/v�r(ité|it|es|er|ez|era|erai|erons|erez|itable|itables|ituellement)/gi, (m, p) => 'vér' + p],
      [/v�tu(e|s|re|res|ement|ements)/gi, (m, p) => 'vêtu' + p],

      [/s�curit�(s)?/gi, (m, p) => 'sécurité' + (p || '')],
      [/s�lection(s)?/gi, (m, p) => 'sélection' + (p || '')],
      [/s�rvice(s)?/gi, (m, p) => 'service' + (p || '')],
      [/s�par(e|er|ez|era|erai|erons|erez|ant|ation|ations|e|es|ement|ements)/gi, (m, p) => 'sépar' + p],
      [/s�quence(s)?/gi, (m, p) => 'séquence' + (p || '')],
      [/s�rie(s)?/gi, (m, p) => 'série' + (p || '')],
      [/s�rieux/gi, 'sérieux'],
      [/s�rim(e|ent|ents)/gi, (m, p) => 'sérim' + p],
      [/s�rolog(ie|ique|iques)/gi, (m, p) => 'sérolog' + p],
      [/s�rum(s)?/gi, (m, p) => 'sérum' + (p || '')],

      [/p�rim(e|er|es|ent|ère|es|ez|era|erai|erons|erez|ant|ètre|ètres)/gi, (m, p) => 'prem' + p],
      [/p�re(s)?/gi, (m, p) => 'père' + (p || '')],
      [/p�riph(érique|ériques|erie|eries)/gi, (m, p) => 'périph' + p],
      [/p�riod(e|es|ique|iques)/gi, (m, p) => 'périod' + p],
      [/p�rim�tre(s)?/gi, (m, p) => 'périmètre' + (p || '')],
      [/p�nal(t|ty|ties)/gi, (m, p) => 'pénal' + p],
      [/p�ch(e|er|ez|era|erai|erons|erez|ant|eaux)/gi, (m, p) => 'pêch' + p],
      [/p�se(s|ur|urs|e|z|aient|ait|ant|er|ez|era|erai|erons|erez|age|ages)?/gi, (m, p) => 'pèse' + (p || '')],

      [/c�bl(er|age|e|es|ages|é|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'câbl' + p],
      [/c�ble(s)?/gi, (m, p) => 'câble' + (p || '')],
      [/c�t�(s)?/gi, (m, p) => 'côté' + (p || '')],
      [/c�ne(s)?/gi, (m, p) => 'cône' + (p || '')],
      [/c�dre(s)?/gi, (m, p) => 'cèdre' + (p || '')],
      [/c�d(e|er|ez|era|erai|erons|erez|ant|re|r)/gi, (m, p) => 'cèd' + p],
      [/c�l(ebre|ebres|èbre|èbres|errer|ez|errera|errerai|errerons|errerez|ant|e|es|er)/gi, (m, p) => 'cél' + p],
      [/c�r(e|er|ez|era|erai|erons|erez|ant|eaux|es)/gi, (m, p) => 'cér' + p],
      [/c�ram(ique|iques|ie)/gi, (m, p) => 'céram' + p],
      [/c�not(e|s|ier|iers)/gi, (m, p) => 'cônot' + p],

      [/f�lix/gi, 'félix'],
      [/f�vrier/gi, 'février'],
      [/f�er(e|ez|era|erai|erons|erez|ait|aient|ant|ies|i)/gi, (m, p) => 'féer' + p],
      [/f�e/gi, 'fée'],
      [/f�ch(e|er|ez|era|erai|erons|erez|ant|eaux|es)/gi, (m, p) => 'fêch' + p],
      [/f�te(s)?/gi, (m, p) => 'fête' + (p || '')],
      [/f�t(e|es|ier|iers|ent|ait|aient)/gi, (m, p) => 'fêt' + p],
      [/f�br(ique|iques|iquer|ez|era|erai|erons|erez|ant|il|ille|illes)/gi, (m, p) => 'fébr' + p],

      [/g�n(e|er|ez|era|erai|erons|erez|ant|eaux|es|ial|iale|iaux|ie)/gi, (m, p) => 'gén' + p],
      [/g�nial(e|s)?/gi, (m, p) => 'génial' + p],
      [/g�nie(s)?/gi, (m, p) => 'génie' + (p || '')],
      [/g�ol(ogie|ogique|ogiques|ogiste|ogistes)/gi, (m, p) => 'géol' + p],
      [/g�om(etrie|étrie|étriques|etrique|étrique|etriques)/gi, (m, p) => 'géom' + p],
      [/g�ran(t|te|tes|tir|ez|tira|tirai|tirons|tirez|tissant)/gi, (m, p) => 'géran' + p],
      [/g�r(d|der|ez|dera|derai|derons|derez|dant|e|es)/gi, (m, p) => 'gér' + p],
      [/g�te(s)?/gi, (m, p) => 'gîte' + (p || '')],

      [/h�berg(e|er|ez|era|erai|erons|erez|ant|eaux|es|ement|ements)/gi, (m, p) => 'héberg' + p],
      [/h�ros/gi, 'héros'],
      [/h�t(e|er|ez|era|erai|erons|erez|ant|eaux|es|ellerie|ellories)/gi, (m, p) => 'hêt' + p],
      [/h�l(ice|ices|iciel|iciels|ico|iques)/gi, (m, p) => 'hél' + p],
      [/h�mor(istique|istiques|iste|istes)/gi, (m, p) => 'hémor' + p],

      [/j�r(ie|ies|idique|idiques|uriste|istes)/gi, (m, p) => 'jur' + p],

      [/l�g(ende|endes|endaire|endaires|er|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'lég' + p],
      [/l�ve(s|r|rs|ment|ments|e|z|aient|ait|ant|er|ez|era|erai|erons|erez)?/gi, (m, p) => 'lève' + (p || '')],
      [/l�g(e|er|ez|era|erai|erons|erez|ant|ers?|ere|eres)/gi, (m, p) => 'lég' + p],
      [/l�ser/gi, 'léser'],
      [/l�s(e|er|ez|era|erai|erons|erez|ant|ion|ions)/gi, (m, p) => 'lés' + p],
      [/l�veil(s)?/gi, (m, p) => 'lèveil' + (p || '')],
      [/l�gue(s)?/gi, (m, p) => 'lègue' + (p || '')],

      [/m�dical(e|s)?/gi, (m, p) => 'médical' + p],
      [/m�diterran(ée|éen|éenne|éens|éennes)/gi, (m, p) => 'méditerran' + p],
      [/m�diocre/gi, 'médiocre'],
      [/m�dium(s)?/gi, (m, p) => 'médium' + (p || '')],
      [/m�di(e|at|ation|ations|ev|eval|evaux|e|es|er|ez|era|erai|erons|erez)/gi, (m, p) => 'médi' + p],
      [/m�mor(ie|ies|iser|ise|ises|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'mémor' + p],
      [/m�me(s)?/gi, (m, p) => 'même' + (p || '')],
      [/m�decin(e|es)/gi, (m, p) => 'médecin' + p],

      [/n�c(essaire|essaires|essaire|essaires|esse|esses)/gi, (m, p) => 'nécess' + p],
      [/n�g(atif|atives|atife|atives|ation|ations|atier|atriers|er|ez|era|erai|erons|erez|ant|lige|liges)/gi, (m, p) => 'nég' + p],
      [/n�goc(e|ier|ez|era|erai|erons|erez|iant|iation|iations)/gi, (m, p) => 'négoc' + p],
      [/n�o(e|n|nat|nate|nates|phrite|phrites|plasme|plasmes)/gi, (m, p) => 'néo' + p],
      [/n�r(e|er|ez|era|erai|erons|erez|ant|e|es|esse|esses|euse|euses)/gi, (m, p) => 'nér' + p],

      // — ê (lettres avant êt/êche/êle) —
    [/pr�t(e|s|er|era|erai|erons|erez|ant|é|ée|ées)?/gi, (m, p) => 'prêt' + (p || '')],
    [/arr�t(e|s|er|era|erai|erons|erez|ant|é|ée|ées)?/gi, (m, p) => 'arrêt' + (p || '')],
    [/t�te(s)?/gi, (m, p) => 'tête' + (p || '')],
    [/t�tu(e|s)?/gi, (m, p) => 'têtu' + (p || '')],
    [/b�te(s)?/gi, (m, p) => 'bête' + (p || '')],
    [/b�che(s)?/gi, (m, p) => 'bêche' + (p || '')],
    [/b�ler/gi, 'bêler'],
    [/cr�te(s)?/gi, (m, p) => 'crête' + (p || '')],
    [/cr�pe(s)?/gi, (m, p) => 'crêpe' + (p || '')],
    [/m�ler/gi, 'mêler'],
    [/m�l(é|ée|ées|e|es)?/gi, (m, p) => 'mêl' + (p || '')],
    [/f�ler/gi, 'fêler'],
    [/f�lure(s)?/gi, (m, p) => 'fêlure' + (p || '')],
    [/for�t(s)?/gi, (m, p) => 'forêt' + (p || '')],

    // — è —
      [/a�/g, 'à'],
      [/d�s/gi, 'dès'],
      [/d�j /gi, 'déj '],
      [/d�j�/gi, 'déjà'],
      [/d�sormais/gi, 'désormais'],
      [/d�shabiller/gi, 'déshabiller'],
      [/d�shidrat(e|ion|ions|er|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'déshidrat' + p],
      [/d�sagr(e|able|ables|er|ez|era|erai|erons|erez|ant)/gi, (m, p) => 'désagr' + p],
      [/cr�/gi, 'cré'],
      [/cr��/gi, 'créé'],
      [/cr�e(s|z|nt|rais|rait|raient|riez|rions|rurent|ut|utes|us|use|uses|ant)?/gi, (m, p) => 'cré' + (p || '')],
      [/entr�e(s)?/gi, (m, p) => 'entrée' + (p || '')],
      [/for�t(s)?/gi, (m, p) => 'forêt' + (p || '')],
      [/f�ch(e|er|ez|era|erai|erons|erez|ant|eaux|es)/gi, (m, p) => 'fêch' + p],
      [/p�che(s|r|er|ez|era|erai|erons|erez|ant|erie|eries|eur|eurs|eaux|e|es)?/gi, (m, p) => 'pêche' + (p || '')],

      // — à —
      [/d�j�/gi, 'déjà'],
      [/l�/gi, 'là'],
      [/d�/gi, 'de'],
      [/o�/gi, 'où'],

      // — ç —
      [/fa�on(s)?/gi, (m, p) => 'façon' + (p || '')],
      [/gar�on(s)?/gi, (m, p) => 'garçon' + (p || '')],
      [/le�on(s)?/gi, (m, p) => 'leçon' + (p || '')],
      [/ma�on(s)?/gi, (m, p) => 'maçon' + (p || '')],
      [/p�ch(e|er|ez|era|erai|erons|erez|ant|eaux|es|erie|eries)/gi, (m, p) => 'pêch' + p],
      [/r�ception(s)?/gi, (m, p) => 'réception' + (p || '')],
      [/r�ussi(e|s|r|re|ez|era|erai|erons|erez|ant|te|tes)/gi, (m, p) => 'réussi' + p],

      // — œ —
      [/cœur(s)?/gi, (m, p) => 'cœur' + (p || '')],
      [/c�ur(s)?/gi, (m, p) => 'cœur' + (p || '')],
      [/sœur(s)?/gi, (m, p) => 'sœur' + (p || '')],
      [/s�ur(s)?/gi, (m, p) => 'sœur' + (p || '')],
      [/�uf(s)?/gi, (m, p) => 'œuf' + (p || '')],
      [/�uvre(s)?/gi, (m, p) => 'œuvre' + (p || '')],
      [/�il(s)?/gi, (m, p) => 'œil' + (p || '')],
      [/fr�quent(e|s|er|ez|era|erai|erons|erez|ant|ation|ations)/gi, (m, p) => 'fréquent' + p],
      [/acc�s(s|ible|ibilité|oires)?/gi, (m, p) => 'accès' + (p || '')],

      // — ù / û —
      [/o�/gi, 'où'],
      [/d�/gi, 'où'],
      [/connu/gi, 'connu'],
      [/re�u/gi, 'reçu'],
      [/re�(e|s|ue|ues)/gi, (m, p) => 'reç' + p],

      // — î / ï —
      [/�le(s)?/gi, (m, p) => 'île' + (p || '')],
      [/ma�tre(s)?/gi, (m, p) => 'maître' + (p || '')],
      [/th�(me|mes|orie|ories|orique|oriques)/gi, (m, p) => 'thé' + p],
      [/na�f(ve|ves|f|ves)?/gi, (m, p) => 'naïf' + (p || '')],
      [/ma�son(s)?/gi, (m, p) => 'maison' + (p || '')],
      [/raison(s)?/gi, (m, p) => 'raison' + (p || '')],

      // — Expressions courantes —
      [/gestion r�/gi, 'gestion ré'],
      [/� /g, 'é '],
      [/ �/g, ' é'],
      [/�-/g, 'é-'],
      [/-�/g, '-é'],
    ];

    for (let i = 0; i < DICT.length; i++) {
      try {
        const newS = s.replace(DICT[i][0], DICT[i][1]);
        if (newS !== s) s = newS;
      } catch (_) {}
    }

    // --- Niveau 3 : Fallback contextuel pour les � restants ---
    if (s.includes('\uFFFD')) {
      s = s.replace(/ \uFFFD /g, ' à ');
      s = s.replace(/^\uFFFD /g, 'À ');
      s = s.replace(/ \uFFFD$/g, ' à');
      s = s.replace(/ \uFFFD(?=[.!?,;:])/g, ' à');
      s = s.replace(/ \uFFFD(?=')/g, ' à');
      s = s.replace(/\bd\uFFFD\b/gi, m => m[0] === 'D' ? 'Dé' : 'dé');
      s = s.replace(/([a-zA-Z])\uFFFD\b/g, (m, prev) => {
        const p = String(prev);
        const isUpper = m[0] === m[0].toUpperCase();
        const accent = (p === 'c') ? 'ç' : 'é';
        return p + (isUpper && p === p.toUpperCase() ? accent.toUpperCase() : accent);
      });
      s = s.replace(/\uFFFD([a-z])/gi, (m, nxt) => {
        const cap = m[0] === m[0].toUpperCase();
        return (cap ? 'É' : 'é') + nxt;
      });
      s = s.replace(/([a-zA-Z])\uFFFD([a-zA-Z])/g, (m, prev, nxt) => prev + 'é' + nxt);
      s = s.replace(/\uFFFD/g, 'é');
    }

    return s;
  }

  static normalize(str) {
    let s = String(str == null ? '' : str).trim();
    s = ImportService.repairMojibake(s);
    s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    s = s.toUpperCase();
    s = s.replace(/\s+/g, ' ').trim();
    return s;
  }

  // Parser un fichier Excel/CSV
  parseFile(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      
      reader.onload = (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          // Options robustes: codepage 65001 = UTF-8 + cellText force strings
          const workbook = XLSX.read(data, { type: 'array', codepage: 65001, cellText: true, cellDates: true });

          // ═══════════════════════════════════════════════════════════════════
          // 🔑 NOUVEAU: SUPPORT 2 ONGLETS FLEXIBLE (VOTRE DEMANDE SPECIALE)
          //    Détecte les onglets:
          //      - Onglet 1: PRODUITS (1ère feuille par défaut)
          //      - Onglet 2: PRODUCT_ATTRIBUTES (product_id/reference/critere/valeur)
          // ═══════════════════════════════════════════════════════════════════
          const sheetNames = workbook.SheetNames;
          const snLowerToIdx = {};
          sheetNames.forEach((n, i) => { snLowerToIdx[ImportService._normalizeHeaderName(n)] = i; });
          const PROD_SYNONYMS = ['produits','produit','products','product','templateimport','template_import','template','modele','main','sheet1','feuille1'];
          const ATTR_SYNONYMS = ['product_attributes','productattribute','productattributs','attributs','attribut','attributes','attribute','critere','criteres','criteria','feuille2','sheet2'];
          let prodSheetIdx = -1;
          for (let i = 0; i < sheetNames.length && prodSheetIdx === -1; i++) {
            const nn = ImportService._normalizeHeaderName(sheetNames[i]);
            if (PROD_SYNONYMS.includes(nn)) prodSheetIdx = i;
          }
          if (prodSheetIdx === -1 && sheetNames.length > 0) prodSheetIdx = 0;
          let attrSheetIdx = -1;
          for (let i = 0; i < sheetNames.length && attrSheetIdx === -1; i++) {
            const nn = ImportService._normalizeHeaderName(sheetNames[i]);
            if (ATTR_SYNONYMS.includes(nn)) attrSheetIdx = i;
          }
          const sheetName = sheetNames[prodSheetIdx];
          const worksheet = workbook.Sheets[sheetName];
          
          const jsonData = XLSX.utils.sheet_to_json(worksheet, { 
            header: 1,
            defval: '',
            raw: false
          });

          // Appliquer REPAIR_MOJIBAKE sur TOUTES les cellules
          const repaired = jsonData.map(row =>
            Array.isArray(row)
              ? row.map(cell => typeof cell === 'string' ? ImportService.repairMojibake(cell) : cell)
              : row
          );
          
          if (repaired.length > 0) {
            const headers = repaired[0] || [];
            const headerIndexMap = {};
            const headerWarnings = [];
            
            // 🔑 DÉTECTION DES EN-TÊTES DUPLIQUÉS
            const headerCount = new Map();
            headers.forEach((h, idx) => {
              if (h === null || h === undefined) return;
              const key = ImportService.repairMojibake(String(h)).trim();
              if (!key) return;
              const normKey = ImportService._normalizeHeaderName(key);
              
              // Détecter les doublons
              if (headerCount.has(key)) {
                headerCount.set(key, headerCount.get(key) + 1);
              } else {
                headerCount.set(key, 1);
              }
              
              headerIndexMap[normKey] = idx;
              headerIndexMap[key] = idx;
            });
            
            // Signaler les en-têtes dupliqués
            headerCount.forEach((count, header) => {
              if (count > 1) {
                headerWarnings.push(`En-tête "${header}" apparaît ${count} fois (colonnes C et D). Seule la première occurrence sera utilisée.`);
              }
            });
            
            if (headerWarnings.length > 0) {
              console.warn('[IMPORT] Avertissements sur les en-têtes:', headerWarnings);
              repaired._headerWarnings = headerWarnings;
            }
            
            repaired._headerIndexMap = headerIndexMap;
            repaired._headers = headers;
            repaired._sheetName = sheetName;
          }

          // ===== 🆕 GESTION FEUILLE PRODUCT_ATTRIBUTES =====
          if (attrSheetIdx !== -1) {
            try {
              const attrSheet = workbook.Sheets[sheetNames[attrSheetIdx]];
              const attrRaw = XLSX.utils.sheet_to_json(attrSheet, { header: 1, defval: '', raw: false });
              const attrRepaired = (attrRaw || []).map(row =>
                Array.isArray(row)
                  ? row.map(cell => typeof cell === 'string' ? ImportService.repairMojibake(cell) : cell)
                  : row
              );
              const twoSheet = ImportService._buildTwoSheetStructure(attrRepaired);
              if (twoSheet) repaired._twoSheet = twoSheet;
            } catch (_e2) { /* ignore 2-sheet parse errors — keep retrocompat */ }
          }

          resolve(repaired);
        } catch (error) {
          reject(new Error('Erreur lors de la lecture du fichier: ' + error.message));
        }
      };
      
      reader.onerror = () => {
        reject(new Error('Erreur lors de la lecture du fichier'));
      };
      
      reader.readAsArrayBuffer(file);
    });
  }

  // 🆕 NOUVEAU: Extrait les lignes ProductAttribute depuis un array 2D de feuille 2
  static _buildTwoSheetStructure(attributesSheetRows) {
    try {
      if (!Array.isArray(attributesSheetRows) || attributesSheetRows.length < 2) return null;
      const attrHeaders = attributesSheetRows[0] || [];
      const attrHeaderIndexMap = {};
      attrHeaders.forEach((h, idx) => {
        if (h == null) return;
        const raw = ImportService.repairMojibake(String(h)).trim();
        if (!raw) return;
        const nk = ImportService._normalizeHeaderName(raw);
        attrHeaderIndexMap[nk] = idx;
        attrHeaderIndexMap[raw] = idx;
      });
      const findAny = (...synonyms) => {
        for (const s of synonyms) {
          const n = ImportService._normalizeHeaderName(s);
          if (attrHeaderIndexMap[n] != null) return attrHeaderIndexMap[n];
          if (attrHeaderIndexMap[s] != null) return attrHeaderIndexMap[s];
        }
        return -1;
      };
      const idCol    = findAny('product_id', 'id_produit', 'id', 'produit_id', 'productId', 'produitId');
      const refCol   = findAny('reference', 'ref', 'référence', 'sku', 'code');
      const critCol  = findAny('critere', 'criterion', 'critère', 'attribute', 'attribut', 'nom', 'name', 'key', 'clef', 'clé');
      const valCol   = findAny('valeur', 'value', 'val', 'attribute_value', 'attribut_valeur');
      const ordCol   = findAny('order', 'position', 'ordre', 'rang', 'sort');
      if (critCol === -1 || valCol === -1 || (idCol === -1 && refCol === -1)) return null;
      const rows = [];
      for (let r = 1; r < attributesSheetRows.length; r++) {
        const row = attributesSheetRows[r];
        if (!row) continue;
        const rawC = row[critCol], rawV = row[valCol];
        const c = rawC == null ? '' : (typeof rawC === 'string' ? ImportService.repairMojibake(rawC).trim() : String(rawC).trim());
        const v = rawV == null ? '' : (typeof rawV === 'string' ? ImportService.repairMojibake(rawV).trim() : String(rawV).trim());
        if (!c) continue;
        const idV  = (idCol !== -1 && row[idCol] != null)   ? String(row[idCol]).trim() : '';
        const rf   = (refCol !== -1 && row[refCol] != null)  ? ImportService.repairMojibake(String(row[refCol])).trim() : '';
        if (!idV && !rf) continue;
        const ordV = ordCol !== -1 && row[ordCol] != null ? Number(row[ordCol]) : null;
        rows.push({ product_id: idV, reference: rf, criterion: c, value: v, order: Number.isFinite(ordV) ? ordV : rows.length });
      }
      return { productAttributes: rows };
    } catch (_e) { return null; }
  }

  // Helper: normaliser un nom d'en-tête Excel → clé mapping (insensible cas/accents/espaces)
  static _normalizeHeaderName(headerStr) {
    let s = String(headerStr || '').trim();
    s = ImportService.repairMojibake(s);
    s = s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    s = s.replace(/[\s\/\\\-–—]+/g, '_');
    s = s.replace(/[^\w]/g, '').replace(/_+/g, '_').replace(/^_|_$/g, '');
    return s;
  }

  // Valider et nettoyer les données d'un produit
  // Nouveau: support du HEADER → INDEX MAP, et fallback sur index historique
  validateProductData(row, rowIndex, headerIndexMap = null, headers = null) {
    const errors = [];
    const product = {};
    // Init facets TRES TOT (avant section Critères / Facettes standards / Colonnes dynamiques)
    product.facets = {};

    // ===== 🆕 MAPPING NORMALISÉ EN-TÊTE → CHAMP PRODUIT =====
    const HEADER_TO_FIELD = {
      'nom': 'name', 'name': 'name', 'produit': 'name', 'libelle': 'name', 'label': 'name',
      'reference': 'sku', 'ref': 'sku', 'sku': 'sku', 'code': 'sku',
      'description': 'description', 'desc': 'description',
      'description_courte': 'shortDescription', 'shortdescription': 'shortDescription',
      'courte_description': 'shortDescription', 'resume': 'shortDescription',
      'description_longue': 'description',

      'famille': 'categoryLevel1', 'lv0': 'categoryLevel1', 'lv0_cat': 'categoryLevel1',
      'categorie_principale': 'categoryLevel1', 'categorieprincipale': 'categoryLevel1', 'catégorie_principale': 'categoryLevel1',
      'categorie_1': 'categoryLevel1', 'niveau_1': 'categoryLevel1',
      'categorie_2': 'categoryLevel2', 'lv1': 'categoryLevel2', 'niveau_2': 'categoryLevel2', 'famille_2': 'categoryLevel2',
      'categorie_3': 'categoryLevel3', 'lv2': 'categoryLevel3', 'niveau_3': 'categoryLevel3', 'famille_3': 'categoryLevel3',
      'categorie_4': 'categoryLevel4', 'lv3': 'categoryLevel4', 'niveau_4': 'categoryLevel4',
      'categorie_5': 'categoryLevel5', 'lv4': 'categoryLevel5', 'niveau_5': 'categoryLevel5',

      'toutes_categories': 'allCategoryNames', 'categories': 'allCategoryNames',
      'all_categories': 'allCategoryNames', 'category_path': 'allCategoryNames',
      'toutes_les_categories': 'allCategoryNames',
      'categorie': 'category', 'category': 'category', 'parent_categorie': 'parentCategory',
      'sous_categories': 'subCategories',
      'categorie_parent': 'parentCategory', 'parent': 'parentCategory',

      'marque': 'brand', 'Marque': 'brand', 'MARQUE': 'brand',
      'brand': 'brand', 'BRAND': 'brand', 'Brand': 'brand',
      'fabricant': 'brand', 'Fabricant': 'brand', 'FABRICANT': 'brand',
      'systeme': 'system', 'Systeme': 'system', 'SYSTEME': 'system',
      'système': 'system', 'Système': 'system', 'SYSTÈME': 'system',
      'system': 'system', 'System': 'system', 'SYSTEM': 'system',
      'famille_systeme': 'system', 'Famille_systeme': 'system',
      'type_de_gaz': 'gasType', 'Type_de_gaz': 'gasType', 'TYPE_DE_GAZ': 'gasType',
      'type de gaz': 'gasType', 'Type de gaz': 'gasType', 'TYPE DE GAZ': 'gasType',
      'gaz_type': 'gasType', 'Gaz_type': 'gasType', 'GAZ_TYPE': 'gasType',
      'gas_type': 'gasType', 'Gas_type': 'gasType', 'GAS_TYPE': 'gasType',
      'gaz': 'gasType', 'Gaz': 'gasType', 'GAZ': 'gasType',
      'type_de_detecteurs': 'detectorType', 'Type_de_detecteurs': 'detectorType', 'TYPE_DE_DÉTECTEURS': 'detectorType',
      'Type de détecteurs': 'detectorType', 'TYPE DE DÉTECTEURS': 'detectorType',
      'detecteur_type': 'detectorType', 'Detecteur_type': 'detectorType', 'DÉTECTEUR_TYPE': 'detectorType',
      'type_detecteur': 'detectorType', 'Type_detecteur': 'detectorType', 'TYPE_DÉTECTEUR': 'detectorType',
      'detector_type': 'detectorType', 'Detector_type': 'detectorType', 'DETECTOR_TYPE': 'detectorType',
      'usage': 'usage', 'Usage': 'usage', 'USAGE': 'usage',
      'utilisation': 'usage', 'Utilisation': 'usage', 'UTILISATION': 'usage',
      'application': 'usage', 'Application': 'usage', 'APPLICATION': 'usage',
      'connectivite': 'connectivity', 'Connectivite': 'connectivity', 'CONNECTIVITÉ': 'connectivity',
      'connectivité': 'connectivity', 'Connectivité': 'connectivity',
      'connexion': 'connectivity', 'Connexion': 'connectivity', 'CONNEXION': 'connectivity',
      'connectivity': 'connectivity', 'Connectivity': 'connectivity', 'CONNECTIVITY': 'connectivity',
      'fonctionnalites': 'functionality', 'Fonctionnalites': 'functionality', 'FONCTIONNALITÉS': 'functionality',
      'fonctionnalités': 'functionality', 'Fonctionnalités': 'functionality',
      'fonctionnalites_specifiques': 'functionality',
      'localisation': 'location', 'Localisation': 'location', 'LOCALISATION': 'location',
      'lieu': 'location', 'Lieu': 'location', 'LIEU': 'location',
      'zone': 'location', 'Zone': 'location', 'ZONE': 'location',
      'phase': 'phase', 'Phase': 'phase', 'PHASE': 'phase',
      'alimentation': 'phase', 'Alimentation': 'phase', 'ALIMENTATION': 'phase',
      'puissance': 'puissance', 'Puissance': 'puissance', 'PUISSANCE': 'puissance',
      'power': 'puissance', 'Power': 'puissance', 'POWER': 'puissance',
      'watt': 'puissance', 'Watt': 'puissance', 'WATT': 'puissance',
      'norme': 'norme', 'Norme': 'norme', 'NORME': 'norme',
      'norme_standard': 'norme', 'Norme_standard': 'norme', 'NORME_STANDARD': 'norme',
      'standard': 'norme', 'Standard': 'norme', 'STANDARD': 'norme',
      'solution': 'solution', 'Solution': 'solution', 'SOLUTION': 'solution',
      'gamme': 'solution', 'Gamme': 'solution', 'GAMME': 'solution',
      'equipement': 'equipement', 'Equipement': 'equipement', 'ÉQUIPEMENT': 'equipement',
      'equipment': 'equipement', 'Equipment': 'equipement', 'EQUIPEMENT': 'equipement',
      'type_equipement': 'equipement', 'Type_equipement': 'equipement', 'TYPE_D\'ÉQUIPEMENT': 'equipement',
      'type_gaz': 'typeGaz', 'Type_gaz': 'typeGaz', 'TYPE_GAZ': 'typeGaz',
      'typegaz': 'typeGaz', 'TypeGaz': 'typeGaz', 'TYPEGAZ': 'typeGaz',
      'categorie_spec': 'categorie', 'Catégorie_spécifique': 'categorie', 'CATÉGORIE_SPÉC': 'categorie',
      'spec_categorie': 'categorie', 'Spec_categorie': 'categorie', 'SPÉC_CATÉGORIE': 'categorie',
      'type_spec': 'type', 'Type_spécifique': 'type', 'TYPE_SPÉC': 'type',
      'spec_type': 'type', 'Spec_type': 'type', 'SPÉC_TYPE': 'type',
      'resolution': 'resolution', 'Résolution': 'resolution', 'RÉSOLUTION': 'resolution',
      'technologie': 'technologie', 'Technologie': 'technologie', 'TECHNOLOGIE': 'technologie',
      'techno': 'technologie', 'Techno': 'technologie', 'TECHNO': 'technologie',
      'technology': 'technologie', 'Technology': 'technologie', 'TECHNOLOGY': 'technologie',
      'debit': 'debit', 'Débit': 'debit', 'DÉBIT': 'debit',
      'flow': 'debit', 'Flow': 'debit', 'FLOW': 'debit',
      'fonctionnalite': 'fonctionnalite', 'Fonctionnalite': 'fonctionnalite', 'FONCTIONNALITÉ': 'fonctionnalite',
      'fonc': 'fonctionnalite', 'Fonc': 'fonctionnalite', 'FONC': 'fonctionnalite',
      'type_detecteur_spec': 'typeDetecteur', 'Type_détecteur_spécifique': 'typeDetecteur', 'TYPE_DÉTECTEUR_SPÉC': 'typeDetecteur',
      'detecteur_spec': 'typeDetecteur', 'Détecteur_spécifique': 'typeDetecteur', 'DÉTECTEUR_SPÉC': 'typeDetecteur',
      'sous_categorie_spec': 'subcategory', 'Sous-catégorie_spécifique': 'subcategory', 'SOUS-CATÉGORIE_SPÉC': 'subcategory',
      'sous_categorie': 'subcategory', 'Sous-catégorie': 'subcategory', 'SOUS-CATÉGORIE': 'subcategory',

      'statut': 'status', 'status': 'status', 'etat': 'status',
      'visible': 'isVisible', 'affiche': 'isVisible', 'is_visible': 'isVisible',
      'mis_en_avant': 'isFeatured', 'featured': 'isFeatured', 'vedette': 'isFeatured',
      'tags': 'tags', 'mots_cles': 'tags', 'keywords': 'seoKeywords',
      'caracteristiques': 'features', 'features': 'features', 'points_forts': 'features',

      'url_image': 'imageUrl', 'image': 'imageUrl', 'image_url': 'imageUrl', 'photo': 'imageUrl',
      'lien_fiche_technique': 'datasheetUrl', 'fiche_technique': 'datasheetUrl', 'datasheet': 'datasheetUrl',
      'lien_manuel': 'manualUrl', 'manuel': 'manualUrl', 'manuel_utilisation': 'manualUrl',
      'lien_certificat': 'certificateUrl', 'certificat': 'certificateUrl', 'certif': 'certificateUrl',
    };

    const ARRAY_FACET_FIELDS = new Set(['functionality','fonctionnalite','tags','features','seoKeywords']);
    const facetFallbackIndex = {
      brand: 10, system: 11, gasType: 12, detectorType: 13, usage: 14,
      connectivity: 15, functionality: 16, location: 17, phase: 18, puissance: 19,
      norme: 20, solution: 21, equipement: 22, typeGaz: 23, categorie: 24, type: 25,
      resolution: 26, technologie: 27, debit: 28, fonctionnalite: 29,
      typeDetecteur: 30, subcategory: 31
    };
    const KNOWN_FACET_FIELDS = new Set(Object.keys(facetFallbackIndex));
    KNOWN_FACET_FIELDS.add('functionality');
    KNOWN_FACET_FIELDS.add('fonctionnalite');

    let getByHeader = null;
    if (headerIndexMap && Object.keys(headerIndexMap).length > 0) {
      getByHeader = (normHeaderName) => {
        const idx = headerIndexMap[normHeaderName];
        if (idx === undefined || idx === null) return null;
        const val = row[idx];
        if (val === null || val === undefined) return null;
        let strVal = typeof val === 'string' ? val.trim() : String(val).trim();
        strVal = ImportService.repairMojibake(strVal);
        return strVal === '' ? null : strVal;
      };
    }

    const getVal = (fieldName, fallbackIndex = null) => {
      if (getByHeader) {
        for (const [hNorm, f] of Object.entries(HEADER_TO_FIELD)) {
          if (f === fieldName) {
            const v = getByHeader(hNorm);
            if (v !== null) return v;
          }
        }
      }
      if (fallbackIndex !== null && fallbackIndex !== undefined) {
        const val = row[fallbackIndex];
        if (val === null || val === undefined) return null;
        let strVal = typeof val === 'string' ? val.trim() : String(val).trim();
        strVal = ImportService.repairMojibake(strVal);
        return strVal === '' ? null : strVal;
      }
      return null;
    };

    // ====== 1. CHAMPS CORE ======
    const name = getVal('name', 0);
    if (name) product.name = name; else errors.push(`Ligne ${rowIndex + 1}: Le nom du produit est requis`);
    const sku = getVal('sku', 1); if (sku) product.sku = sku;
    const desc = getVal('description', 2); if (desc) product.description = desc;
    const sdesc = getVal('shortDescription', null); if (sdesc) product.shortDescription = sdesc;

    // ====== 2. CATÉGORIES (Niveaux 1..5) ======
    // Historique: ancien index 4=Famille (avant suppression colonne Description courte).
    // 🆕 NOUVEAU LAYOUT: Description courte SUPPRIMÉE (colonne D). Donc index 3=CatPrincipale.
    // ✅ FORÇAGE PAR POSITION COLONNE : colonne D = index 3 -> Catégorie principale / Famille
    {
      const rawD = (row != null && row[3] !== undefined && row[3] !== null) ? (typeof row[3] === 'string' ? row[3] : String(row[3])).trim() : '';
      const familleForceD = rawD ? ImportService.repairMojibake(rawD) : '';
      if (familleForceD) {
        product.facets = product.facets || {};
        if (!product.facets.Famille)   product.facets.Famille   = familleForceD;
        if (!product.facets.lvlFamille) product.facets.lvlFamille = familleForceD;
        if (!product.facets.famille)   product.facets.famille   = familleForceD;
        product.categoryPath = product.categoryPath && product.categoryPath.length > 0
          ? [familleForceD, ...product.categoryPath.filter(c => String(c) !== familleForceD)]
          : [familleForceD];
      }
    }
    const categoryLevels = ['categoryLevel1','categoryLevel2','categoryLevel3','categoryLevel4','categoryLevel5'];
    const fallbackIdxCat = [3, null, null, null, null];
    categoryLevels.forEach((cl, i) => {
      const v = getVal(cl, fallbackIdxCat[i]);
      if (v) {
        product.categoryPath = product.categoryPath || [];
        product.categoryPath.push(v);
      }
    });

    // ====== 2bis. 🔑 PAIRES CRITÈRE / VALEUR (Critère 1 -> Valeur Critère 1) =========
    //     Correspondance EXCEL COLONNES (NOUVEAU LAYOUT SANS DESCRIPTION COURTE):
    //        A=0  B=1  C=2  D=3  E=4  F=5  G=6  H=7  I=8  J=9  K=10 ...
    //       (D=3=Famille/CatPrincipale  E=4=NomFiltre1  F=5=NomFiltre2  G=6=ValFiltre1  H=7=ValFiltre2  I=8=Marque  J=9=Système …)
    //     Supporte N=1..20, en-tête name ou index fallback.
    //     Accepte des libellés irréguliers comme "Valeur Critère 1", "Valeur Critère Critère1", "Valeur du Critère1", etc.
    {
      const SAFE_NAME_RE = /^[a-z\u00C0-\u017F][a-z0-9_\u00C0-\u017F\s\-\/\\]*$/i;
      const cleanRow = (val) => {
        if (val === null || val === undefined) return null;
        const s = (typeof val === 'string' ? val : String(val)).trim();
        const r = ImportService.repairMojibake(s);
        return r === '' ? null : r;
      };
      const getRawByFallbackIndex = (idx) => (idx == null ? null : cleanRow(row[idx]));

      // Helper: extraire N depuis un en-tête de type "Critère 12", "Nom Filtre 12", "Valeur Filtre 3", "Valeur Critère 3", …
      const extractCritNumber = (hRaw) => {
        if (!hRaw) return null;
        const h = String(hRaw).trim();
        if (!h) return null;
        // Pattern principal : "…(Crit(ère|ere|)|Nom[_\s]*Filtre|Filtre)[^0-9]*)(\d+)"
        // 🔑 MODIF: plus de limite "n <= 20" (supporte Critère 21, Nom Filtre 50, Valeur Filtre 100…)
        const m = h.match(/(?:(?:crit(?:[èe]re)?)|(?:nom[_\s-]*filtre)|(?:valeur[_\s-]*filtre)|(?:filtre))\D*(\d+)/i);
        if (!m) return null;
        const n = parseInt(m[1], 10);
        if (!Number.isFinite(n) || n <= 0) return null;
        return n;
      };
      const isValueHeader = (hRaw) => {
        if (!hRaw) return false;
        return /valeur|val/i.test(String(hRaw).trim());
      };

      // Étape A: Parcourir TOUS les en-têtes pour détecter dynamiquement les colonnes
      // (insensible à l'ordre exact des colonnes — prend même en compte colonnes hors index historique)
      const dynCritColByN   = new Map(); // n → idx colonne du NOM du critère (Critère N)
      const dynValueColByN  = new Map(); // n → idx colonne de la VALEUR (Valeur Critère N)
      if (headers && headerIndexMap) {
        Object.entries(headerIndexMap).forEach(([hNorm, idx]) => {
          const origHeader = headers[idx] || hNorm;
          const n = extractCritNumber(origHeader) || extractCritNumber(hNorm);
          if (n == null) return;
          if (isValueHeader(origHeader) || /^valeur/i.test(hNorm)) {
            if (!dynValueColByN.has(n)) dynValueColByN.set(n, idx);
          } else {
            if (!dynCritColByN.has(n))  dynCritColByN.set(n, idx);
          }
        });
      }

      // Étape B: Ajout positions connues (colonnes Excel standards) en tant que fallback
      //   NOUVEAU LAYOUT (sans Description courte, colonne D=3=CatPrincipale) :
      //     D=3=CatPrincipale, E=4=Filtre1, F=5=Filtre2, G=6=Val1, H=7=Val2, I=8=Marque, J=9=Système, ...
      //     → PAS de filtres 3/4/5 en colonnes fixes (l'utilisateur doit utiliser le nommage explicite "Nom Filtre N" pour N>=3, auto-détecté)
      const FALLBACK_CRIT  = new Map([[1, 4], [2, 5]]);
      const FALLBACK_VALUE = new Map([[1, 6], [2, 7]]);
      FALLBACK_CRIT.forEach((idx, n)  => { if (!dynCritColByN.has(n))  dynCritColByN.set(n, idx); });
      FALLBACK_VALUE.forEach((idx, n) => { if (!dynValueColByN.has(n)) dynValueColByN.set(n, idx); });

      const addCriterePairByN = (n) => {
        if (!product || typeof product !== 'object') return;
        let kV = null, vV = null;
        const idxK = dynCritColByN.get(n);
        const idxV = dynValueColByN.get(n);

        if (getByHeader) {
          try {
            // Tous les alias possibles pour le NOM du filtre (format nouveau: Nom Filtre N / format ancien: Critère N)
            const aliasesKey = [
              // 🔑 NOUVEAU FORMAT PLUS CLAIR
              `Nom Filtre ${n}`, `NomFiltre${n}`, `Nom_Filtre_${n}`, `Nom-Filtre-${n}`,
              `Filtre ${n}`, `Filtre${n}`,
              `NOM_FILTRE_${n}`, `nom_filtre_${n}`,
              // FORMAT ANCIEN (compat ascendante)
              `Critère ${n}`, `Critere ${n}`, `Critere${n}`, `Critère${n}`,
              `Crit ${n}`, `C${n}`,
              `lvlCrit${n}`, `lvlCrit ${n}`,
              `CRITERE_${n}`, `critere_${n}`,
              `Critère  ${n}` // double espace (erreur courante copier-coller)
            ];
            for (const ak of aliasesKey) {
              const kn = ImportService._normalizeHeaderName(ak);
              const t = getByHeader(kn);
              if (t !== null && t !== undefined && String(t).trim() !== '') {
                kV = cleanRow(t);
                if (kV) break;
              }
            }
            if (!kV && idxK != null) kV = getRawByFallbackIndex(idxK);

            // Tous les alias possibles pour la VALEUR associée (nouveau + ancien)
            const aliasesVal = [
              // 🔑 NOUVEAU FORMAT PLUS CLAIR
              `Valeur Filtre ${n}`, `ValeurFiltre${n}`, `Valeur_Filtre_${n}`, `Valeur-Filtre-${n}`,
              `VALEUR_FILTRE_${n}`, `valeur_filtre_${n}`,
              `Val Filtre ${n}`, `VF${n}`,
              // FORMAT ANCIEN (compat ascendante)
              `Valeur Critère ${n}`,
              `Valeur Critere ${n}`,
              `Valeur Critère ${n} `,
              `Valeur Critère  ${n}`,
              `ValeurCritère${n}`,
              `ValeurCritere${n}`,
              `Valeur CritèreCritère${n}`, // "Valeur Critère Critère1"
              `Valeur CritereCritere${n}`,
              `Valeur du Critère ${n}`,
              `Valeur Crit ${n}`,
              `VC${n}`,
              `lvlValCrit${n}`,
              `lvlValCrit ${n}`,
              `VALEUR_CRITERE_${n}`,
              `valeur_critere_${n}`,
              `Valeur Critère Critère${n}`, // variante avec accent
              `Critère ${n} Valeur`,
              `Valeur Critère Critere${n}`
            ];
            for (const av of aliasesVal) {
              const vn = ImportService._normalizeHeaderName(av);
              const t = getByHeader(vn);
              if (t !== null && t !== undefined && String(t).trim() !== '') {
                vV = cleanRow(t);
                if (vV) break;
              }
            }
            if (!vV && idxV != null) vV = getRawByFallbackIndex(idxV);
          } catch (_) {}
        } else {
          if (idxK != null) kV = getRawByFallbackIndex(idxK);
          if (idxV != null) vV = getRawByFallbackIndex(idxV);
        }

        if (!kV || typeof kV !== 'string' || kV.length < 1) return;
        if (!SAFE_NAME_RE.test(kV)) return;
        const fKey = ImportService._normalizeHeaderName(kV) || kV;
        if (!fKey) return;
        if (!product.facets) product.facets = {};
        const BLACKLIST = new Set(['__proto__','constructor','prototype']);
        if (BLACKLIST.has(fKey) || BLACKLIST.has(kV.toLowerCase())) return;
        
        // 🔑 NORMALISATION DE CASSE : convertir en majuscules pour éviter les doublons
        const normalizedCrit = kV.toUpperCase();
        const normalizedVal = vV ? vV.toUpperCase() : '';
        
        try {
          const exist = Object.prototype.hasOwnProperty.call(product.facets, fKey) ? product.facets[fKey] : undefined;
          if (exist !== undefined && exist !== null && (Array.isArray(exist) ? exist.length > 0 : String(exist).trim() !== '')) return;
          product.facets[fKey] = normalizedVal ?? '';
          // Écriture miroir DOUBLE (nouveau format + ancien format) → garantit compatibilité totale
          const canonCritKey      = `Critère ${n}`;
          const canonValKey       = `Valeur Critère ${n}`;
          const newCanonCritKey   = `Nom Filtre ${n}`;
          const newCanonValKey    = `Valeur Filtre ${n}`;
          if (!product.facets[canonCritKey])       product.facets[canonCritKey]       = normalizedCrit;
          if (!product.facets[newCanonCritKey])    product.facets[newCanonCritKey]    = normalizedCrit;
          if (normalizedVal) {
            if (!product.facets[canonValKey])      product.facets[canonValKey]       = normalizedVal;
            if (!product.facets[newCanonValKey])   product.facets[newCanonValKey]    = normalizedVal;
          }
        } catch (_) {}
      };

      try {
        // 🔑 MODIF: Détecter le N MAX DYNAMIQUEMENT dans les en-têtes ET les fallbacks, sans limitation codée en dur.
        //    (ex: si l'en-tête contient "Critère 77" alors maxNCrit = 77, et on boucle 1..77)
        let maxNCrit = 0;
        for (const n of [...dynCritColByN.keys(), ...dynValueColByN.keys()]) {
          if (Number.isFinite(n) && n > maxNCrit) maxNCrit = n;
        }
        // Plancher au minimum 5 pour conserver le fallback positionnel historique (min F/G/H/I/J)
        if (maxNCrit < 5) maxNCrit = 5;
        for (let n = 1; n <= maxNCrit; n++) addCriterePairByN(n);

        // 🟢 LOG TEMPORAIRE SPEC #4 : vérifie paires importées PAR PRODUIT
        //     SORTIE ATTENDUE :
        //     UPS-3KVA-001   → famille=SITE IMANE, items=[{n:1, nom:"DOMOELEC", valeur:"TARIK"}]
        //     UPS-3KVA-001-2 → famille=SITE IMANE, items=[{n:2, nom:"EVOLUTEL", valeur:"ISMAIL"}]
        try {
          const __debugItems = [];
          for (let nn = 1; nn <= maxNCrit; nn++) {
            const aliasesCrit = [`Nom Filtre ${nn}`, `Critère ${nn}`, `Critere ${nn}`];
            const aliasesVal  = [`Valeur Filtre ${nn}`, `Valeur Critère ${nn}`, `Valeur Critere ${nn}`];
            let nomDebug = null;
            let valDebug = null;
            for (const ak of aliasesCrit) {
              const v = product.facets ? product.facets[ImportService._normalizeHeaderName(ak)] ?? product.facets[ak] : null;
              if (v != null && String(v).trim() !== '') { nomDebug = String(v).trim(); break; }
            }
            for (const av of aliasesVal) {
              const v = product.facets ? product.facets[ImportService._normalizeHeaderName(av)] ?? product.facets[av] : null;
              if (v != null && String(v).trim() !== '') { valDebug = String(v).trim(); break; }
            }
            if (nomDebug || valDebug) {
              __debugItems.push({ n: nn, nom: nomDebug ?? '', valeur: valDebug ?? '' });
            }
          }
          const familleDebug = product.facets
            ? (product.facets['Catégorie principale']
              ?? product.facets.Famille
              ?? product.facets.famille
              ?? product.facets.lvlFamille
              ?? '')
            : '';
          console.log("IMPORT PAIRS", {
            reference: product.reference ?? null,
            name: product.name ?? null,
            famille: familleDebug,
            items: __debugItems,
            rawFacetKeys: product.facets ? Object.keys(product.facets).slice(0, 20) : []
          });
        } catch(_le) { /* ignore log errors */ }
      } catch (_outer) {
        // Sécurité: ne jamais casser tout l'import sur une paire de critères
      }
    }
    const allCats = getVal('allCategoryNames', 9);
    if (allCats) {
      // 🆕 RÈGLE SPEC "CATÉGORIE → SOUS-CATÉGORIE → SOUS-SOUS-CATÉGORIE → VALEUR" :
      //    Si une partie contient "/" OU " > " OU " \ " → c'est un PATH HIÉRARCHIQUE
      //    (ex: "finale / finale test / test" → [finale, finale test, test]).
      //    Sinon (séparateur , ou | sans slash) → ce sont des CATÉGORIES INDÉPENDANTES.
      const rawParts = allCats.split(/[,|]/).map(s => ImportService.repairMojibake(s).trim()).filter(Boolean);
      const flatCats = [];
      for (const part of rawParts) {
        if (/[\\/>]/.test(part)) {
          const pathSplit = part.split(/\s*[\\/>]\s*/).map(s => s.trim()).filter(Boolean);
          if (pathSplit.length > 0) {
            // 🆕 UN PATH HIÉRARCHIQUE → utilise categoryPath (crée la cascade finale→sous1→sous2)
            product.categoryPath = product.categoryPath && product.categoryPath.length > 0
              ? [...product.categoryPath, ...pathSplit]
              : pathSplit;
          }
        } else {
          flatCats.push(part);
        }
      }
      if (flatCats.length > 0) {
        product.categoryNames = flatCats;
        if (!product.category) product.category = flatCats[0];
      }
    }
    const singleCat = getVal('category', null); if (singleCat && !product.category) product.category = singleCat;

    // ====== 3. META / STATUS ======
    const status = getVal('status', 32); if (status) product.status = status;
    const isVis = getVal('isVisible', 33);
    if (isVis !== null) { product.isVisible = String(isVis).toLowerCase().match(/^(oui|true|1|yes|vrai|y)$/i) ? true : false; }
    const isFeat = getVal('isFeatured', 34);
    if (isFeat !== null) { product.isFeatured = String(isFeat).toLowerCase().match(/^(oui|true|1|yes|vrai|y)$/i) ? true : false; }
    const tags = getVal('tags', 35);
    if (tags && typeof tags === 'string') product.tags = tags.split(/[,;]/).map(s => ImportService.repairMojibake(s).trim()).filter(Boolean);
    const features = getVal('features', 36);
    if (features && typeof features === 'string') product.features = features.split(/[;|]/).map(s => ImportService.repairMojibake(s).trim()).filter(Boolean);

    // ====== 4. MÉDIAS ======
    const imgU = getVal('imageUrl', 37);
    if (imgU) {
      product.imageUrls = product.imageUrls || []; product.imageUrls.push(imgU); product.imageUrl = imgU;
      if (googleDriveService.isGoogleDriveUrl(imgU)) {
        product.isGoogleDriveImage = true;
        product.googleDriveUrls = product.googleDriveUrls || []; product.googleDriveUrls.push(imgU);
      }
    }
    const ds = getVal('datasheetUrl', 38); if (ds) { product.documents = product.documents||{}; product.documents.datasheet = ds; product.datasheetUrl = ds; }
    const mn = getVal('manualUrl', 39);    if (mn) { product.documents = product.documents||{}; product.documents.manual = mn; product.manualUrl = mn; }
    const cf = getVal('certificateUrl', 40); if (cf) { product.documents = product.documents||{}; product.documents.certificate = cf; product.certificateUrl = cf; }

    // ====== 5. FACETTES STANDARD ======
    // ⚠️ IMPORTANT: ne plus faire product.facets = {} ici — ça aurait écrasé
    //   les facettes insérées en section 2bis (paires Critère/Valeur). Init fait ligne 112.
    if (!product.facets) product.facets = {};
    KNOWN_FACET_FIELDS.forEach(field => {
      const v = getVal(field, facetFallbackIndex[field] ?? null);
      if (v === null || v === '') return;
      const exist = product.facets[field];
      if (exist !== undefined && exist !== null && (Array.isArray(exist) ? exist.length > 0 : String(exist).trim() !== '')) return; // ne pas écraser valeur déjà présente
      if (ARRAY_FACET_FIELDS.has(field) && typeof v === 'string') {
        product.facets[field] = v.split(/[,;]/).map(s => ImportService.repairMojibake(s).trim()).filter(Boolean);
      } else {
        product.facets[field] = v;
      }
    });

    // ====== 6. 🆕 COLONNES DYNAMIQUES INCONNUES → deviennent FACETTES ======
    if (headers && headerIndexMap) {
      const consumedNorm = new Set(Object.keys(HEADER_TO_FIELD));
      const allHeaderNormKeys = Object.keys(headerIndexMap).filter(h => /^[a-z0-9_]+$/i.test(h));
      for (const hNorm of allHeaderNormKeys) {
        if (consumedNorm.has(hNorm)) continue;
        const idx = headerIndexMap[hNorm];
        if (idx === undefined) continue;
        let val = row[idx];
        if (val === null || val === undefined) continue;
        let strVal = typeof val === 'string' ? val.trim() : String(val).trim();
        if (!strVal) continue;
        strVal = ImportService.repairMojibake(strVal);
        let facetKey = hNorm;
        if (!facetKey) facetKey = `custom_${idx}`;
        if (product.facets[facetKey] !== undefined && product.facets[facetKey] !== null && product.facets[facetKey] !== '') continue;
        product.facets[facetKey] = strVal;
        product[facetKey] = strVal;
      }
      // Sécurité: colonnes index > 40 (hors ancien mapping) qui n'auraient pas de header mappé
      for (let idx = 41; idx < row.length; idx++) {
        const val = row[idx];
        if (val === null || val === undefined) continue;
        let strVal = typeof val === 'string' ? val.trim() : String(val).trim();
        if (!strVal) continue;
        strVal = ImportService.repairMojibake(strVal);
        const hName = headers && headers[idx] ? ImportService._normalizeHeaderName(String(headers[idx])) : `column_${idx}`;
        if (!hName) continue;
        if (product.facets[hName] !== undefined && product.facets[hName] !== null && product.facets[hName] !== '') continue;
        product.facets[hName] = strVal;
        product[hName] = strVal;
      }
    }

    // ====== 6 BIS. 🎯 CANONISATION: clés aliasées (Marque → brand, Système → system, …) ======
    //    Évite: colonne Excel "Marque" apparaît comme Critère dans UI au lieu de facette Brand
    {
      if (!product.facets) product.facets = {};
      const CANON = [
        // [liste des alias (normalisés), clé canonique facets, affichage FR]
        { aliases: ['Marque','MARQUE','marque','Brand','BRAND','brand','Fabricant','FABRICANT','fabricant'], canon: 'brand' },
        { aliases: ['Systeme','SYSTEME','systeme','Système','SYSTÈME','système','System','SYSTEM','system','Famille_systeme','famille_systeme'], canon: 'system' },
        { aliases: ['Type_de_gaz','TYPE_DE_GAZ','Type de gaz','TYPE DE GAZ','type_de_gaz','Gaz_type','GAZ_TYPE','gaz_type','Gas_type','GAS_TYPE','gas_type','Gaz','GAZ','gaz'], canon: 'gasType' },
        { aliases: ['Type_de_detecteurs','TYPE_DE_DÉTECTEURS','Type de détecteurs','TYPE DE DÉTECTEURS','type_de_detecteurs','Detecteur_type','DÉTECTEUR_TYPE','detecteur_type','Type_detecteur','TYPE_DÉTECTEUR','type_detecteur','Detector_type','DETECTOR_TYPE','detector_type'], canon: 'detectorType' },
        { aliases: ['Usage','USAGE','usage','Utilisation','UTILISATION','utilisation','Application','APPLICATION','application'], canon: 'usage' },
        { aliases: ['Connectivite','CONNECTIVITÉ','connectivite','Connectivité','connectivité','Connexion','CONNEXION','connexion','Connectivity','CONNECTIVITY','connectivity'], canon: 'connectivity' },
        { aliases: ['Fonctionnalites','FONCTIONNALITÉS','fonctionnalites','Fonctionnalités','fonctionnalités','Fonctionnalites_specifiques'], canon: 'functionality' },
        { aliases: ['Localisation','LOCALISATION','localisation','Lieu','LIEU','lieu','Zone','ZONE','zone'], canon: 'location' },
        { aliases: ['Phase','PHASE','phase','Alimentation','ALIMENTATION','alimentation'], canon: 'phase' },
        { aliases: ['Puissance','PUISSANCE','puissance','Power','POWER','power','Watt','WATT','watt'], canon: 'puissance' },
        { aliases: ['Norme','NORME','norme','Norme_standard','NORME_STANDARD','norme_standard','Standard','STANDARD','standard'], canon: 'norme' },
        { aliases: ['Solution','SOLUTION','solution','Gamme','GAMME','gamme'], canon: 'solution' },
        { aliases: ['Equipement','ÉQUIPEMENT','equipement','Equipment','EQUIPEMENT','equipment','Type_equipement',"TYPE_D'ÉQUIPEMENT",'type_equipement'], canon: 'equipement' },
        { aliases: ['Type_gaz','TYPE_GAZ','type_gaz','TypeGaz','TYPEGAZ','typegaz'], canon: 'typeGaz' },
        { aliases: ['Categorie_spec','CATÉGORIE_SPÉC','categorie_spec','Catégorie_spécifique','Spec_categorie','SPÉC_CATÉGORIE','spec_categorie'], canon: 'categorie' },
        { aliases: ['Type_spec','TYPE_SPÉC','type_spec','Type_spécifique','Spec_type','SPÉC_TYPE','spec_type'], canon: 'type' },
        { aliases: ['Resolution','Résolution','RÉSOLUTION','resolution'], canon: 'resolution' },
        { aliases: ['Technologie','TECHNOLOGIE','technologie','Techno','TECHNO','techno','Technology','TECHNOLOGY','technology'], canon: 'technologie' },
        { aliases: ['Debit','DÉBIT','debit','Flow','FLOW','flow'], canon: 'debit' },
        { aliases: ['Fonctionnalite','FONCTIONNALITÉ','fonctionnalite','Fonc','FONC','fonc'], canon: 'fonctionnalite' },
        { aliases: ['Type_detecteur_spec','TYPE_DÉTECTEUR_SPÉC','type_detecteur_spec','Type_détecteur_spécifique','Detecteur_spec','DÉTECTEUR_SPÉC','detecteur_spec','Détecteur_spécifique'], canon: 'typeDetecteur' },
        { aliases: ['Sous_categorie_spec','SOUS-CATÉGORIE_SPÉC','sous_categorie_spec','Sous-catégorie_spécifique','Sous_categorie','SOUS-CATÉGORIE','sous_categorie','Sous-catégorie'], canon: 'subcategory' },
      ];
      // Parcourir chaque règle: si facet alias existe et canon vide, copier vers canon
      CANON.forEach(rule => {
        const { aliases, canon } = rule;
        // 1) si product.facets[canon] n'est pas renseigné mais un des alias l'est → sync vers canon
        const canonEmpty = (product.facets[canon] === undefined || product.facets[canon] === null || String(product.facets[canon]).trim() === '' || (Array.isArray(product.facets[canon]) && product.facets[canon].length === 0));
        if (canonEmpty) {
          for (const alias of aliases) {
            const v = product.facets[alias];
            if (v !== undefined && v !== null && (typeof v === 'string' ? String(v).trim() !== '' : (Array.isArray(v) ? v.length > 0 : true))) {
              product.facets[canon] = v;
              break;
            }
          }
        }
        // 2) Inverse: si canon renseigné ET un alias est absent → on remplit l'alias le plus courant pour rétrocompatibilité
        //    (ex: facets.brand = "APC" → facets.Marque = "APC" pour les vieux filtres familyCriteres "Marque")
        if (product.facets[canon] !== undefined && product.facets[canon] !== null) {
          for (const alias of aliases) {
            if (product.facets[alias] === undefined || product.facets[alias] === null || String(product.facets[alias]).trim() === '') {
              product.facets[alias] = product.facets[canon];
            }
          }
        }
      });
      // 3) Si colonne K "Marque" a atterri comme custom facetKey "Marque" → on s'assure d'avoir aussi l'équivalent product.brand
      if (product.facets.brand && (product.brand === undefined || product.brand === null || String(product.brand).trim() === '')) {
        product.brand = typeof product.facets.brand === 'string' ? product.facets.brand : (Array.isArray(product.facets.brand) ? product.facets.brand[0] : String(product.facets.brand));
      }
      // 4) productAttributes 2-sheet: si criterion est un alias → doublon avec version canonique (conserve les 2 pour rétro compat)
      if (Array.isArray(product.productAttributes) && product.productAttributes.length > 0) {
        const extra = [];
        product.productAttributes.forEach(a => {
          if (a && a.criterion) {
            const rule = CANON.find(r => r.aliases.some(al => String(al).trim().toLowerCase() === String(a.criterion).trim().toLowerCase()));
            if (rule && rule.canon !== String(a.criterion).trim()) {
              const exists = product.productAttributes.some(b => b && String(b.criterion || '').trim().toLowerCase() === String(rule.canon).trim().toLowerCase() && String(b.value || '').trim().toLowerCase() === String(a.value || '').trim().toLowerCase());
              if (!exists) {
                extra.push({ criterion: rule.canon, value: a.value, ordre: a.ordre });
              }
            }
          }
        });
        if (extra.length > 0) product.productAttributes = [...product.productAttributes, ...extra];
      }
    }

    // Vérifications obligatoires
    if (!product.name) {
      errors.push(`Ligne ${rowIndex + 1}: Le nom du produit est requis`);
    }

    if (errors.length === 0) {
      if (!product.facets) product.facets = {};
      if (!product.tags) product.tags = [];
      if (!product.features) product.features = [];
      if (!product.technicalSpecs) product.technicalSpecs = [];
      if (!product.seoKeywords) product.seoKeywords = [];
      if (product.isVisible === undefined) product.isVisible = true;
      if (product.isFeatured === undefined) product.isFeatured = false;
    }

    return { product, errors };
  }

  // Traiter les images Google Drive - Optimisé
  async processGoogleDriveImages(products, onProgress = null) {
    const productsWithGoogleDrive = products.filter(p => p.isGoogleDriveImage);
    
    if (productsWithGoogleDrive.length === 0) {
      return products;
    }

    const allGoogleDriveUrls = [];
    const productUrlMap = new Map();

    for (let i = 0; i < productsWithGoogleDrive.length; i++) {
      const product = productsWithGoogleDrive[i];
      if (product.googleDriveUrls && product.googleDriveUrls.length > 0) {
        for (let j = 0; j < product.googleDriveUrls.length; j++) {
          const imageUrl = product.googleDriveUrls[j];
          allGoogleDriveUrls.push(imageUrl);
          if (!productUrlMap.has(imageUrl)) {
            productUrlMap.set(imageUrl, []);
          }
          productUrlMap.get(imageUrl).push({ productIndex: i, imageIndex: j });
        }
      }
    }

    // Télécharger toutes les images en parallèle
    const downloadResults = await googleDriveService.downloadMultipleImages(
      allGoogleDriveUrls, 
      onProgress
    );

    for (let i = 0; i < downloadResults.length; i++) {
      const result = downloadResults[i];
      const originalUrl = result.originalUrl;
      const productMappings = productUrlMap.get(originalUrl);

      if (productMappings) {
        for (const mapping of productMappings) {
          const product = productsWithGoogleDrive[mapping.productIndex];
          if (!product.images) product.images = [];

          if (result.success) {
            product.images.push({
              main: result.filepath,
              filename: result.filename,
              originalUrl: originalUrl
            });
          } else if (result.skipped) {
            product._skippedImages = (product._skippedImages || 0) + 1;
          } else {
            console.error(`❌ Erreur téléchargement image pour ${product.name || mapping.productIndex}:`, result.error);
            product._imageErrors = (product._imageErrors || 0) + 1;
          }
        }
      }
    }

    return products;
  }

  // Envoyer les produits avec images au backend
  async bulkImportWithImages(products) {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

    const productsData = [];

    for (let i = 0; i < products.length; i++) {
      const product = { ...products[i] };

      // Correction: dans processGoogleDriveImages on stocke .main, pas .path
      if (product.images && product.images.length > 0) {
        const validImages = product.images.filter(img => img && (img.main || img.path));
        product.images = {
          main: validImages[0]?.main || validImages[0]?.path || null,
          gallery: validImages.slice(1).map(img => img.main || img.path).filter(Boolean)
        };
      } else {
        product.images = {
          main: null,
          gallery: []
        };
      }

      productsData.push(product);
    }

    const response = await fetch(`${API_BASE_URL}/products/bulk-import`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`,
      },
      body: JSON.stringify({ products: productsData })
    });

    if (!response.ok) {
      let msg = `Erreur HTTP ${response.status}: ${response.statusText}`;
      try {
        const j = await response.json();
        if (j && j.message) msg = j.message;
      } catch (_) {}
      throw new Error(msg);
    }

    return await response.json();
  }

  // Importer les produits
  async importProducts(file, onProgress) {
    try {
      // Parser le fichier
      const data = await this.parseFile(file);

      if (data.length < 2) {
        throw new Error('Le fichier doit contenir au moins un en-tête et une ligne de données');
      }

      const headerIndexMap = data._headerIndexMap || null;
      const headersArr = data._headers || null;
      const rows = data.slice(1);
      
      const products = [];
      const frontendErrorDetails = [];
      let processed = 0;

      for (let i = 0; i < rows.length; i++) {
        const row = rows[i];

        if (row.every(cell => !cell || cell.toString().trim() === '')) {
          continue;
        }

        const { product, errors } = this.validateProductData(row, i, headerIndexMap, headersArr);
        
        if (errors.length > 0) {
          const tentativeName = product?.name
            || (row[0] && String(row[0]).trim())
            || '(Sans nom)';
          errors.forEach(errMsg => {
            frontendErrorDetails.push({
              index: i,
              product: tentativeName,
              error: String(errMsg)
            });
          });
        } else {
          // 🔑 NOUVEAU: Attach product_id / reference à ce produit (1 based) pour jointure 2-sheet
          product._excelRowIndex = i + 2; // +2: header ligne 1, rows.slice(1) donc 0 => excel ligne 2
          // Récupérer product_id de la ligne Excel si colonne "product_id" / "id" est présente
          if (headerIndexMap && headersArr) {
            const findColBySyn = (...syn) => {
              for (const s of syn) {
                const nk = ImportService._normalizeHeaderName(s);
                if (headerIndexMap[nk] != null) return headerIndexMap[nk];
                if (headerIndexMap[s] != null) return headerIndexMap[s];
              }
              return -1;
            };
            const pidCol = findColBySyn('product_id','id','productId','produit_id','id_produit');
            const refCol = findColBySyn('reference','ref','référence','sku','code');
            if (pidCol !== -1 && row[pidCol] != null) {
              product._excelProductId = String(row[pidCol]).trim();
            }
            if (refCol !== -1 && row[refCol] != null) {
              product._excelReference = ImportService.repairMojibake(String(row[refCol])).trim();
              if (product._excelReference && !product.reference) product.reference = product._excelReference;
              if (product._excelReference && !product.sku) product.sku = product._excelReference;
            }
          }
          products.push(product);
        }

        processed++;
        
        if (onProgress) {
          const rowsProgress = Math.round((processed / rows.length) * 70);
          onProgress(rowsProgress);
        }
      }

      // ═══════════════════════════════════════════════════════════════════
      // 🔑 NOUVEAU: JOINDRE FEUILLE 2 (PRODUCT_ATTRIBUTES) AUX PRODUITS
      //    Par product_id (si colonne présente dans feuille 1) OU par reference (unique)
      // ═══════════════════════════════════════════════════════════════════
      if (data._twoSheet && Array.isArray(data._twoSheet.productAttributes) && data._twoSheet.productAttributes.length > 0) {
        const attrRows = data._twoSheet.productAttributes;
        // Build map: pid (string) → attrs[] AND ref (normalized) → attrs[]
        const byPid = new Map();
        const byRef = new Map();
        for (const a of attrRows) {
          if (a.product_id) {
            if (!byPid.has(a.product_id)) byPid.set(a.product_id, []);
            byPid.get(a.product_id).push(a);
          }
          if (a.reference) {
            const nk = ImportService.normalize(a.reference);
            if (!byRef.has(nk)) byRef.set(nk, []);
            byRef.get(nk).push(a);
          }
        }
        let matched = 0;
        for (const p of products) {
          const joined = new Map(); // {criterion} => { criterion, value, order }
          const tryAddFromList = (list) => {
            if (!Array.isArray(list) || list.length === 0) return 0;
            let added = 0;
            for (const a of list) {
              const ck = ImportService.normalize(a.criterion);
              if (!ck) continue;
              const key = ck;
              if (!joined.has(key)) {
                joined.set(key, { criterion: String(a.criterion).trim(), value: String(a.value || '').trim(), order: Number.isFinite(a.order) ? a.order : joined.size });
                added++;
              }
            }
            return added;
          };
          if (p._excelProductId && byPid.has(p._excelProductId)) tryAddFromList(byPid.get(p._excelProductId));
          if (p._excelReference && byRef.has(ImportService.normalize(p._excelReference))) tryAddFromList(byRef.get(ImportService.normalize(p._excelReference)));
          if (p.reference && byRef.has(ImportService.normalize(p.reference))) tryAddFromList(byRef.get(ImportService.normalize(p.reference)));
          if (p.sku && byRef.has(ImportService.normalize(p.sku))) tryAddFromList(byRef.get(ImportService.normalize(p.sku)));
          // Fallback: si pas de product_id ni reference dans p (colonnes absentes de la feuille produits), 
          // on map par _excelRowIndex (ligne N = produit N, les product_id N correspondent)
          if (joined.size === 0 && p._excelRowIndex != null) {
            const pidAsString = String(p._excelRowIndex);
            if (byPid.has(pidAsString)) tryAddFromList(byPid.get(pidAsString));
            if (byPid.has(String(p._excelRowIndex - 1))) tryAddFromList(byPid.get(String(p._excelRowIndex - 1)));
          }
          if (joined.size > 0) {
            p.productAttributes = Array.from(joined.values()).sort((a, b) => Number(a.order) - Number(b.order));
            matched++;
            // Aussi écrire dans facets (rétro-compat) pour les logiques historiques productController _filterProductsByFcPairs fallback facets
            if (!p.facets) p.facets = {};
            for (const a of p.productAttributes) {
              const nk = ImportService._normalizeHeaderName(a.criterion);
              if (nk && (p.facets[nk] === undefined || p.facets[nk] === '')) p.facets[nk] = a.value;
              if ((p.facets[a.criterion] === undefined || p.facets[a.criterion] === '')) p.facets[a.criterion] = a.value;
            }
            // Écrire aussi dans facets miroir Critère N / Valeur Critère N pour compat Critère1=Puissance / ValeurCritère1=3KVA
            let nCounter = 1;
            for (const a of p.productAttributes) {
              const canonCrit = `Critère ${nCounter}`;
              const canonVal  = `Valeur Critère ${nCounter}`;
              const newCCanon  = `Nom Filtre ${nCounter}`;
              const newVCanon  = `Valeur Filtre ${nCounter}`;
              if (!p.facets[canonCrit])  p.facets[canonCrit] = a.criterion;
              if (!p.facets[newCCanon])  p.facets[newCCanon] = a.criterion;
              if (a.value && !p.facets[canonVal]) p.facets[canonVal] = String(a.value);
              if (a.value && !p.facets[newVCanon])  p.facets[newVCanon] = String(a.value);
              nCounter++;
            }
          }
        }
        console.log(`[importProducts 2-sheet] jointure OK: ${matched}/${products.length} produits ont ${attrRows.length} attributs.`);
      }

      if (products.length === 0) {
        if (onProgress) onProgress(100);
        const nbErr = frontendErrorDetails.length;
        return {
          success: true,
          imported: 0,
          errors: nbErr,
          details: frontendErrorDetails,
          message: nbErr > 0
            ? `Import terminé: 0 produits importés, ${nbErr} erreurs (validation avant envoi — corriger les lignes)`
            : 'Aucune ligne de données trouvée dans le fichier'
        };
      }

      // Traiter les images Google Drive avant d'envoyer au backend
      const productsWithImages = await this.processGoogleDriveImages(products, (imageProgress, message) => {
        if (onProgress) {
          // Images: 70% → 90%
          const totalProgress = 70 + Math.round((imageProgress / 100) * 20);
          onProgress(totalProgress);
        }
      });

      // Envoyer les produits au backend (90% → 100%)
      if (onProgress) onProgress(95);
      const response = await this.bulkImportWithImages(productsWithImages);
      if (onProgress) onProgress(100);

      const backendDetails = Array.isArray(response.details) ? response.details : [];
      const backendErrors = Number(response.errors) || 0;
      const backendImported = Number(response.imported) || 0;
      const totalErrors = frontendErrorDetails.length + backendErrors;
      const mergedDetails = [...frontendErrorDetails, ...backendDetails];

      return {
        success: true,
        imported: backendImported,
        errors: totalErrors,
        details: mergedDetails,
        message: response.message
          ? `${response.message}${frontendErrorDetails.length ? ` (+ ${frontendErrorDetails.length} erreurs de validation Excel)` : ''}`
          : `Import terminé: ${backendImported} produits importés, ${totalErrors} erreurs`
      };

    } catch (error) {
      console.error('Erreur lors de l\'import:', error);
      const errMsg = error.message || 'Erreur lors de l\'import des produits';
      return {
        success: true,
        imported: 0,
        errors: 1,
        details: [
          {
            index: 0,
            product: '(Import global)',
            error: errMsg
          }
        ],
        message: errMsg
      };
    }
  }

  // Télécharger un modèle Excel
  downloadTemplate() {
    const templateData = [
      [
        'Nom', 'Référence', 'Description', 'Description courte', 'Famille (Niveau 1 catégorie)',
        'Critère 1 (nom facet)', 'Critère 2 (nom facet)',
        'Valeur Critère 1', 'Valeur Critère 2',
        'Catégories (toutes) — séparateur / pour hiérarchie, ex: "finale / sous-cat / sous-sous-cat", ou , pour multiples',
        'Marque', 'Système', 'Type de gaz', 'Type de détecteurs', 'Usage', 'Connectivité', 'Fonctionnalités',
        'Statut', 'Visible', 'Mis en avant', 'Tags', 'Caractéristiques',
        'URL Image', 'Lien fiche technique', 'Lien manuel', 'Lien certificat'
      ],
      [
        'Détecteur ponctuel Gamme 3000 NUG30252-2', 'NUG30252-2', 'Détecteur ponctuel de la gamme 3000', 'Détecteur Ponctuel Gamme 3000',
        'ouss',
        'imane', 'testouss',
        'testtyyy', 'dddd',
        'ouss / imane / testouss, Équipements Électriques',
        'APC', 'Système UPS', '', '', '', '', '',
        'Publié', 'Oui', 'Non', 'détecteur,3000', '',
        '', '', '', ''
      ],
      [
        'Produit exemple finale 2 sous-cats', 'FINALE-001', 'Exemple produit finale avec 2 niveaux sous-catégories', 'Exemple finale',
        'finale',
        'finale test', 'test',
        'fin', 'dddd',
        'finale / finale test, finale / test',
        '', '', '', '', '', '', '',
        'Publié', 'Oui', 'Non', '', '',
        '', '', '', ''
      ]
    ];

    const ws = XLSX.utils.aoa_to_sheet(templateData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Modèle');
    
    XLSX.writeFile(wb, 'modele-import-produits.xlsx');
  }
}

export const importService = new ImportService();
